<div class="topbar">
  <nav class="navbar navbar-mycustom w-100">

    <div class="nav-item text-center" style="margin-top:11px; margin-right: 40px" [routerLink]="['']">
      <div class="navbar-brand">
        <img [src]="siteicon" />
      </div>
      <!-- <h3>{{siteurl}}</h3> -->
    </div>
    @if (isAdmin) {
<div class="nav-item d-none d-sm-block" style="margin-top: 10px" [routerLink]="['/client/selection']" title="Sélection client">
      <button class="button-menu-mobile open-left">
        <i class="zmdi zmdi-accounts-outline" style="font-size: 36px"></i>
      </button>
    </div>
}
    <div class="nav-item d-none d-sm-block" style="margin-top: 10px" [routerLink]="['/contact/list']" title="Listes de contacts">
      <button class="button-menu-mobile open-left">
        <i class="zmdi zmdi-accounts-add" style="font-size: 36px"></i>
      </button>
    </div>
    <div class="nav-item d-none d-sm-block" style="margin-top: 9px">
      <button class="button-menu-mobile open-left" [routerLink]="['/campagne/creation/1']" title="Créer une campagne">
        <i class="zmdi zmdi-comment-text" style="font-size: 26px"></i>
      </button>
    </div>
    <div class="nav-item d-none d-sm-block" style="margin-top: 9px">
      <button class="button-menu-mobile open-left" [routerLink]="['/campagne/status/encours']" title="Campagnes en cours">
        <i class="zmdi zmdi-traffic" style="font-size: 30px"></i>
      </button>
    </div>
    <div class="nav-item d-none d-sm-block" style="margin-top: 9px">
      <button class="button-menu-mobile open-left" [routerLink]="['/client/edition']" title="Edition client">
        <i class="zmdi zmdi-odnoklassniki" style="font-size: 30px"></i>
      </button>
    </div>
    <div class="nav-item d-none d-sm-block" style="margin-top: 9px">
      <button class="button-menu-mobile open-left" [routerLink]="['/client/credit']" title="Crédit client">
        <i class="zmdi zmdi-info" style="font-size: 30px"></i>
      </button>
    </div>
    @if (!isAdmin) {
    <div class="nav-item d-none d-sm-block" style="margin-top: 9px">
      <button class="button-menu-mobile open-left" [routerLink]="['/nous_contacter']" title="Nous contacter">
        <i class="zmdi zmdi-email" style="font-size: 30px"></i>
      </button>
    </div>
    }

    <div class="nav-item d-block d-sm-none" style="margin-top: 9px; margin-left: 10px" [routerLink]="['']" title="menu">
      <button class="button-menu-mobile open-left">
        <i class="fa fa-home fa-2x"></i>
      </button>
    </div>

    <div class="nav-item" style="margin-top: 9px; margin-left: auto">
      <button class="button-menu-mobile open-left" (click)="logout()" title="Se déconnecter">
        <i class="zmdi zmdi-power" style="font-size: 30px"></i>
      </button>
    </div>
    @if (watchdog?.actif) {
    <div class="nav-item" style="margin-top: 9px; margin-left: 100px; color:orange">
      Déconnexion dans {{watchdog.countdown}} sec !
    </div>
    }

    <div class="clearfix"></div>
    @if (client?.disabled==1 && !isAdmin) {
    <div class="text-center">
      <div class="text text-warning blink suspendu">Votre compte est suspendu !!</div>
    </div>
    }
    @if (client?.disabled==2 && !isAdmin) {
    <div class="text-center">
      <div class="text text-warning blink suspendu">Votre compte est en attente de validation !!</div>
    </div>
    }
  </nav>
</div>


<app-modal [(isActive)]="showLogoutConfirm" [overlayDismiss]="true" (overlayClick)="showLogoutConfirm=false">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Déconnexion ? </h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="showLogoutConfirm=false">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" data-dismiss="modal"
      (click)="showLogoutConfirm=false">Annuler</button>
      <button type="button" class="btn btn-primary" (click)='logoutConfirm()'>Valider</button>
    </div>
  </div>
</app-modal>
